import { createContext, useContext, useEffect, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { auth, database } from "../firebase/firebaseConfig";
import { ref, onValue } from "firebase/database";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [currentUser, setCurrentUser] = useState(null);
    const [userLoading, setUserLoading] = useState(true);

    useEffect(() => {

        let stopProfile = () => {};
        let generation = 0;
        const unsubscribe = onAuthStateChanged(auth, (authUser) => {
            stopProfile();
            stopProfile = () => {};
            const version = ++generation;
            try {

                setUserLoading(true);

                // ❌ no user
                if (!authUser) {
                    setCurrentUser(null);
                    setUserLoading(false);
                    return;
                }

                // ⚡ instant basic user (NO delay UI)
                const baseUser = {
                    uid: authUser.uid,
                    email: authUser.email,
                };

                // 🔥 fetch realtime DB profile
                const userRef = ref(database, `Users/${authUser.uid}`);
                stopProfile = onValue(userRef, (snap) => {
                    if (version !== generation) return;
                    setCurrentUser({ ...baseUser, ...(snap.val() || {}) });
                    setUserLoading(false);
                }, (error) => {
                    if (version !== generation) return;
                    console.error("Could not refresh account access", error);
                    setCurrentUser(null);
                    setUserLoading(false);
                });

            } catch (error) {
                console.error("AuthContext error:", error);
                setCurrentUser(null);
                setUserLoading(false);
            }
        });

        return () => {
            generation += 1;
            stopProfile();
            unsubscribe();
        };
    }, []);

    return (
        <AuthContext.Provider value={{ currentUser, userLoading }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
